<script>
import {webBackend as hyperionNav,webReporting as  reportNav} from './config/navigation'

export default {
  props: {
    backend: {
      type: Boolean,
      default: false
    },
    sidebar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    navigation() {
      return this.backend ? this.hyperionNav : this.reportNav
    },
    openedKeys() {
      if (this.collapsed)
        return []

      return this.activeKeys
    },
    activeKeys() {
      let opened =  []
      let route = this.getRoute()
      _.forIn(this.navigation, function(value, key) {
        if ((value.route === route && value.route !== null) || route.startsWith(value.route)) {
          opened.push(key)
        }

        if (_.isObject(value.children)) {
          _.forIn(value.children, function(v,k) {
            if (v.route === route && v.route !== null) {
              opened.push(key)
              opened.push(k)
            }
          })
        }
      })

      return opened
    },
    screenSize() {
      return this.getScreenSize()
    },
    layoutClasses() {
      return [
        'layout',
        'base-layout',
        `screen-${this.screenSize}`,
        {
          'mobile-view': this.screenSize === 'mobile',
          'tablet-view': this.screenSize === 'tablet',
          'desktop-view': ['small-desktop', 'desktop', 'large-desktop'].includes(this.screenSize)
        }
      ]
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    if (localStorage.getItem('is_collapsed') !== null) {
      this.collapsed = (localStorage.getItem('is_collapsed') === 'true')
    }

    // Auto-collapse on mobile/tablet for better UX
    this.handleResponsiveCollapse()

    this.interval = setInterval(() => {
      this.timestamp = this.moment().locale('id').format('dddd, D MMMM YYYY HH:mm:ss')
    }, 1000)
  },
  mounted() {
    this.registerListener();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    clearInterval(this.interval)
    window.removeEventListener('resize', this.handleResize);
  },
  data() {
    return {
      collapsed: true,
      hyperionNav,
      reportNav,
      timestamp: '',
      interval: null,
      windowWidth: window.innerWidth
    }
  },
  methods: {
    navigate(route) {
      let router = this.route(route)
      window.location.href = (router) ? '/' + router.uri : window.location.pathname
    },
    registerListener() {
      Echo.private('hyperion-notif-export')
        .listen('Export.SendMessage', (data) => {
            this.$notification.info({
              message: 'Information',
              description: data.message,
              duration: 0,
            })
        })
    },
    handleResize() {
      this.windowWidth = window.innerWidth
      this.handleResponsiveCollapse()
    },
    handleResponsiveCollapse() {
      const screenWidth = window.innerWidth

      // Auto-collapse logic based on screen size
      if (screenWidth <= 768) {
        // Tablet and mobile - force collapse for better UX
        this.collapsed = true
      } else if (screenWidth <= 992) {
        // Small desktop - collapse by default but allow manual toggle
        if (localStorage.getItem('is_collapsed') === null) {
          this.collapsed = true
        }
      } else {
        // Large desktop - use stored preference or default to expanded
        if (localStorage.getItem('is_collapsed') === null) {
          this.collapsed = false
        }
      }
    },
    getScreenSize() {
      const width = this.windowWidth
      if (width <= 480) return 'mobile'
      if (width <= 768) return 'tablet'
      if (width <= 992) return 'small-desktop'
      if (width <= 1200) return 'desktop'
      return 'large-desktop'
    }
  },
  watch: {
    collapsed(value) {
      localStorage.setItem('is_collapsed', value)
    }
  }
}
</script>
<template>
  <a-layout id="app" class="layout base-layout">
    <a-layout>
      <a-layout-header class="header ant-header-fixedHeader horizontal-nav">
        <div class="nav-container">
          <div class="nav-left">
            <div class="logo horizontal-logo">
              <img src="/assets/bank-aceh-logo.png" alt="Logo" />
            </div>
            <a-menu theme="light" mode="horizontal" :defaultSelectedKeys="activeKeys" class="horizontal-menu">
              <template v-for="(item, index) in navigation">

                <template v-if="item.children === null && item.role.includes(user().role)">
                  <a-menu-item :key="index">
                    <a :href="routeUri(item.route)" v-shortkey="item.shortKey" @shortkey="navigate(item.route)">
                      <a-icon :type="item.icon"/>
                      <span>{{ item.text }}</span>
                    </a>
                  </a-menu-item>
                </template>

                <template v-else>
                  <a-sub-menu :key="index" v-if="item.role.includes(user().role)">
                    <span slot="title"> <a-icon :type="item.icon"/> <span>{{ item.text }}</span></span>
                    <template v-for="(cItem, cIndex) in item.children">

                      <template v-if="cItem.children === null && cItem.role.includes(user().role)">
                        <a-menu-item :key="cIndex">
                          <a :href="routeUri(cItem.route)" v-shortkey="cItem.shortKey" @shortkey="navigate(cItem.route)">
                            <span>{{ cItem.text }}</span>
                          </a>
                        </a-menu-item>
                      </template>

                      <template v-else>
                        <a-sub-menu :key="cIndex" :title="cItem.text" v-if="cItem.role.includes(user().role)">
                          <a-menu-item v-for="(cItem2Deep, cIndex2Deep) in cItem.children" :key="cIndex2Deep">
                            <a v-shortkey="cItem2Deep.shortKey" @shortkey="navigate(cItem2Deep.route)" :href="routeUri(cItem2Deep.route)">
                              <span>{{ cItem2Deep.text }}</span>
                            </a>
                          </a-menu-item>
                        </a-sub-menu>
                      </template>

                    </template>
                  </a-sub-menu>
                </template>

              </template>
            </a-menu>
          </div>
          <div class="header-right">
            <div class="header-clock">
              <span class="time-display">
                <a-icon type="clock-circle" />
                {{ timestamp }}
              </span>
            </div>
            <user-header :backend="backend" class="user-header-component"/>
          </div>
        </div>
      </a-layout-header>
      <a-layout class="page-container">
        <a-layout-sider width="200" style="background: #fff !important" v-if="sidebar">
          <slot name="sidebar-menu"></slot>
        </a-layout-sider>

        <a-layout-content class="page-container">
          <slot name="page-container">
            <slot name="page-header"></slot>

            <a-layout-content class="page-content">
              <slot name="content"></slot>
            </a-layout-content>
          </slot>

          <a-layout-footer :style="{margin: '24px 16px', padding: 0}">
            <slot name="footer"></slot>
          </a-layout-footer>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<style lang="less">
.base-layout {
  .horizontal-nav {
    background: #fff;
    height: 64px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    position: sticky;
    top: 0;
    z-index: 1000;

    .nav-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      padding: 0 24px;
      max-width: 100%;
      width: 100%;
    }

    .nav-left {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
    }

    .horizontal-logo {
      height: 40px;
      margin-right: 24px;
      display: flex;
      align-items: center;
      flex-shrink: 0;

      img {
        height: 32px;
        width: auto;
        max-width: 120px;
      }
    }

    .horizontal-menu {
      flex: 1;
      background: transparent;
      border-bottom: none;
      min-width: 0;

      .ant-menu-item {
        color: #333;
        font-weight: 500;
        margin: 0 4px;

        &:hover {
          color: #1890ff;
          background-color: rgba(24, 144, 255, 0.05);
        }

        &.ant-menu-item-selected {
          color: #1890ff;
          background-color: rgba(24, 144, 255, 0.1);
        }
      }

      .ant-menu-submenu {
        margin: 0 4px;

        .ant-menu-submenu-title {
          color: #333;
          font-weight: 500;

          &:hover {
            color: #1890ff;
            background-color: rgba(24, 144, 255, 0.05);
          }
        }

        &.ant-menu-submenu-selected {
          .ant-menu-submenu-title {
            color: #1890ff;
            background-color: rgba(24, 144, 255, 0.1);
          }
        }
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;
      margin-left: auto;
    }

    .header-clock {
      display: flex;
      align-items: center;

      .time-display {
        display: flex;
        align-items: center;
        font-size: 13px;
        font-weight: 500;
        color: #1f2937;
        background: rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 6px 12px;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(0, 0, 0, 0.08);
          border-color: rgba(0, 0, 0, 0.15);
        }

        .anticon {
          margin-right: 6px;
          font-size: 14px;
        }
      }
    }

    .user-header-component {
      display: flex;
      align-items: center;
    }
  }

  // Responsive design for header
  @media (max-width: 1200px) {
    .horizontal-nav {
      .nav-container {
        padding: 0 16px;
      }

      .horizontal-logo {
        margin-right: 16px;
      }

      .header-right {
        gap: 12px;
        
        .header-clock .time-display {
          padding: 5px 10px;
          font-size: 12px;
        }
      }
    }
  }

  @media (max-width: 992px) {
    .horizontal-nav {
      .nav-container {
        padding: 0 12px;
      }

      .horizontal-menu {
        .ant-menu-item {
          margin: 0 2px;
          font-size: 14px;
        }

        .ant-menu-submenu {
          margin: 0 2px;

          .ant-menu-submenu-title {
            font-size: 14px;
          }
        }
      }

      .header-clock {
        .time-display {
          font-size: 11px;
          padding: 3px 6px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .horizontal-nav {
      height: 56px;

      .nav-container {
        padding: 0 8px;
      }

      .horizontal-logo {
        margin-right: 12px;
        height: 36px;

        img {
          height: 28px;
        }
      }

      .horizontal-menu {
        .ant-menu-item {
          margin: 0 1px;
          font-size: 13px;
          padding: 0 8px;
        }

        .ant-menu-submenu {
          margin: 0 1px;

          .ant-menu-submenu-title {
            font-size: 13px;
            padding: 0 8px;
          }
        }
      }

      .header-right {
        gap: 8px;
        
        .header-clock .time-display {
          padding: 4px 8px;
          font-size: 11px;
          
          .anticon {
            margin-right: 4px;
            font-size: 12px;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .horizontal-nav {
      height: 52px;

      .nav-container {
        padding: 0 6px;
      }

      .nav-left {
        min-width: 0;
        overflow: hidden;
      }

      .horizontal-logo {
        margin-right: 8px;
        height: 32px;

        img {
          height: 24px;
          max-width: 80px;
        }
      }

      .horizontal-menu {
        min-width: 0;
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          display: none;
        }

        .ant-menu-item {
          margin: 0;
          font-size: 12px;
          padding: 0 6px;
          white-space: nowrap;

          span {
            display: none;
          }

          .anticon {
            margin-right: 0;
          }
        }

        .ant-menu-submenu {
          margin: 0;

          .ant-menu-submenu-title {
            font-size: 12px;
            padding: 0 6px;

            span:last-child {
              display: none;
            }

            .anticon {
              margin-right: 0;
            }
          }
        }
      }

      .header-right {
        gap: 6px;
        flex-shrink: 0;
        
        .header-clock {
          display: none;
        }
      }
    }
  }
}

.base-layout {
  // Base responsive sidebar behavior
  .ant-layout-sider {
    transition: all 0.2s;
  }

  // Desktop and large screens (> 1200px)
  @media (min-width: 1201px) {
    .ant-layout-sider:not(.ant-layout-sider-collapsed) {
      width: 270px !important;
      min-width: 270px !important;
      max-width: 300px !important;
      flex: 0 0 270px !important;
    }
  }

  // Medium desktop screens (992px - 1200px)
  @media (min-width: 993px) and (max-width: 1200px) {
    .ant-layout-sider:not(.ant-layout-sider-collapsed) {
      width: 260px !important;
      min-width: 260px !important;
      max-width: 280px !important;
      flex: 0 0 260px !important;
    }
  }

  // Small desktop/tablet landscape (769px - 992px)
  @media (min-width: 769px) and (max-width: 992px) {
    .ant-layout-sider:not(.ant-layout-sider-collapsed) {
      width: 240px !important;
      min-width: 240px !important;
      max-width: 260px !important;
      flex: 0 0 240px !important;
    }

    // Slightly smaller font for medium screens
    .ant-menu {
      font-size: 13px;
    }
  }

  // Tablet portrait and mobile landscape (481px - 768px)
  @media (max-width: 768px) {
    .ant-layout-sider:not(.ant-layout-sider-collapsed) {
      width: 210px !important;
      min-width: 210px !important;
      max-width: 230px !important;
      flex: 0 0 210px !important;
    }

    // Smaller font and padding for tablets
    .ant-menu {
      font-size: 12px;

      .ant-menu-item,
      .ant-menu-submenu-title {
        padding-left: 16px !important;
        padding-right: 16px !important;
      }
    }

    // Auto-collapse on tablet for better UX
    &.base-layout {
      .collapsed {
        .ant-layout-sider {
          width: 80px !important;
        }
      }
    }
  }

  // Mobile screens (≤ 480px)
  @media (max-width: 480px) {
    // Force collapsed mode on mobile
    .ant-layout-sider {
      width: 0 !important;
      min-width: 0 !important;

      &.ant-layout-sider-collapsed {
        width: 60px !important;
        min-width: 60px !important;
      }

      // Hide text, show only icons on mobile
      .ant-menu-item,
      .ant-menu-submenu-title {
        span:not(.anticon) {
          display: none !important;
        }
      }
    }

    // Mobile header adjustments
    .ant-layout-header {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }

  // Ensure menu text doesn't get truncated with responsive considerations
  .ant-layout-sider .ant-menu {
    .ant-menu-item,
    .ant-menu-submenu-title {
      white-space: nowrap !important;
      overflow: visible !important;
      text-overflow: unset !important;
      width: auto !important;

      span {
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: unset !important;
        display: inline !important;
        max-width: none !important;

        // Responsive font scaling
        @media (max-width: 768px) {
          font-size: 0.9em;
        }

        @media (max-width: 480px) {
          font-size: 0.8em;
        }
      }

      a {
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: unset !important;

        span {
          white-space: nowrap !important;
          overflow: visible !important;
          text-overflow: unset !important;
          display: inline !important;
          max-width: none !important;
        }
      }
    }

    // Responsive submenu items
    .ant-menu-sub {
      .ant-menu-item {
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: unset !important;
        width: auto !important;

        span {
          white-space: nowrap !important;
          overflow: visible !important;
          text-overflow: unset !important;
          display: inline !important;
          max-width: none !important;
        }

        a {
          white-space: nowrap !important;
          overflow: visible !important;

          span {
            white-space: nowrap !important;
            overflow: visible !important;
            text-overflow: unset !important;
            display: inline !important;
            max-width: none !important;
          }
        }
      }
    }
  }

  // Enhanced collapsed state with responsive behavior
  .ant-layout-sider-collapsed {
    .ant-menu-item,
    .ant-menu-submenu-title {
      &:hover {
        width: auto !important;

        // Show tooltip-like behavior on hover for collapsed state
        span {
          display: inline !important;
          white-space: nowrap !important;
          overflow: visible !important;
          position: relative;
          z-index: 1000;
          background-color: #001529;
          padding: 4px 8px;
          border-radius: 4px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        }
      }
    }
  }

  // Responsive content area adjustments
  @media (max-width: 768px) {
    .page-container {
      margin: 0 !important;
      padding: 8px !important;
    }

    .page-content {
      padding: 16px !important;
    }
  }

  @media (max-width: 480px) {
    .page-container {
      margin: 0 !important;
      padding: 4px !important;
    }

    .page-content {
      padding: 8px !important;
    }
  }
}
</style>
